import { useNavigation } from "@react-navigation/native";
import { Info, Pen, Trash2 } from "@tamagui/lucide-icons";
import { uuid } from "expo-modules-core";
import { observer } from "mobx-react-lite";
import React, { useCallback } from "react";
import { Pressable } from "react-native";
import { Text, XStack, YStack } from "tamagui";
import {
  type SortableItemWithId,
  SortableList,
} from "../../../core/components/SortableList";
import { Body } from "../../../ui/Body";
import { Box } from "../../../ui/Box";
import { Button } from "../../../ui/Button";
import { InfoRow } from "../../../ui/InfoRow";
import { Input } from "../../../ui/InputNew";
import { Label } from "../../../ui/Label";
import { PopoverConfirm } from "../../../ui/PopoverConfirm";
import type {
  BusinessTemplateModel,
  BusinessTemplateSection,
} from "./BusinessTemplateModel";

export const BusinessAdminTemplateSections = observer(
  ({ template }: { template: BusinessTemplateModel }) => {
    const navigation = useNavigation();

    const [sectionTitle, setSectionTitle] = React.useState("");

    const renderItem = useCallback(
      (listItem: SortableItemWithId<BusinessTemplateSection>) => {
        const section = listItem.item;

        return (
          <Pressable
            key={section.uid}
            onPress={() => {
              navigation.navigate("CustomerAdminTemplateSectionEdit", {
                customerUid: template.data.customerUid,
                templateUid: template.uid,
                sectionUid: section.uid,
              });
            }}
          >
            <YStack gap={"$medium"}>
              <Body>{section.title}</Body>
              <InfoRow
                items={[
                  {
                    icon: Info,
                    text: <Text>{section.businessModules.length} items</Text>,
                  },
                  {
                    icon: Pen,
                    text: <Text cursor="pointer">Edit</Text>,
                  },
                  {
                    icon: Trash2,
                    text: (
                      <PopoverConfirm
                        placement="top-start"
                        onConfirm={() => {
                          template.deleteBusinessTemplateSection(section);
                        }}
                      >
                        <Text cursor="pointer">Delete</Text>
                      </PopoverConfirm>
                    ),
                  },
                ]}
              />
            </YStack>
          </Pressable>
        );
      },
      [template, navigation],
    );

    return (
      <YStack>
        <Box>
          <Label>Sections</Label>
          <SortableList
            items={template.data.sections}
            onChange={(items) => {
              template?.updateSectionOrder(items.map((i) => i.item));
            }}
            renderItem={renderItem}
          />
        </Box>

        <Box>
          <XStack gap={"$medium"}>
            <Input
              submitOnEnter
              onSubmitEditing={(e) => {
                const text = e.nativeEvent.text;
                if (text) {
                  template.addBusinessSection({
                    uid: uuid.v4(),
                    title: sectionTitle,
                    emoji: null,
                    businessModules: [],
                  });
                }
              }}
              flex={1}
              placeholder={"New section name..."}
              type="border"
              defaultValue={undefined}
              onChangeText={(text) => {
                setSectionTitle(text);
              }}
            />

            <Button
              onPress={() => {
                if (sectionTitle) {
                  template.addBusinessSection({
                    uid: uuid.v4(),
                    title: sectionTitle,
                    emoji: null,
                    businessModules: [],
                  });
                }
              }}
            >
              Add section
            </Button>
          </XStack>
        </Box>
      </YStack>
    );
  },
);
